import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import { formatCpfCnpj } from '../../../../helpers/utils/utils';
import * as C from '../../../theme/colors.constants';

/**
 * Dados do(s) Sócio(s) do devedor (AW2-1134 Etapa 7) — porta de
 * `DadosSocios.jsx` real, tabela somente-leitura (Nome/CPF) — sem `if` de
 * PF/PJ: renderizada incondicionalmente, mesmo comportamento da produção
 * (`formFields?.socios || []` — PF nunca tem sócios no DTO, resulta em 0
 * linhas sem erro, não um `if (categoria === 'PESSOA_JURIDICA')` explícito).
 *
 * CPF exibido via `formatCpfCnpj` (mesmo utilitário puro já usado em
 * `IdentificacaoDevedor.jsx` para o CPF/CNPJ do devedor) — igual à produção
 * real (`formatCpfCnpj(socio.cpf?.value)`).
 *
 * Sem `onClick`/log em nenhum campo — CPF de sócio é PII (requisito de
 * segurança explícito do plano desta etapa); nunca passar `socios`/`cpf`
 * para `console.*` neste componente ou no mapper (`devedorController.js`).
 */
export default function DadosSocios({ socios }) {
  return (
    <>
      <Typography variant="h3" sx={{ mt: 3, mb: 1.5 }}>Dados do(s) Sócio(s):</Typography>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>CPF</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {socios.map(socio => (
              <TableRow key={socio.idSocio || socio.nome} hover>
                <TableCell sx={{ color: C.navy, fontWeight: 600 }}>{socio.nome}</TableCell>
                <TableCell>{socio.cpf ? formatCpfCnpj(socio.cpf) : ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
}

DadosSocios.propTypes = {
  socios: PropTypes.arrayOf(PropTypes.shape({
    idSocio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    nome: PropTypes.string,
    cpf: PropTypes.string,
  })),
};

DadosSocios.defaultProps = {
  socios: [],
};
